const eventCategory = 'tv_login';

export const logTvConnectionSuccess = (platform?: string): void => {
  window.dataLayer?.push({
    event: 'device_connected',
    'clear-eventCategory': eventCategory,
    'clear-eventAction': 'device_connected',
    'clear-eventLabel': 'success',
    platformValue: platform,
  });
};
